<template>
	<div class="filled-content">
		<v-toolbar app flat dark color="primary">
			<v-btn icon @click="gotoMap()">
				<v-icon>arrow_back</v-icon>
			</v-btn>
			<v-toolbar-title>Mijn E-finders</v-toolbar-title>
			<v-btn icon @click="showMenu()">
				<v-icon>menu</v-icon>
			</v-btn>
		</v-toolbar>

		<v-content class="uf-form">
			<v-container class="pt-1" style="background: white;">
				<v-text-field
					@input="query = $event"
					placeholder="Zoeken..."
					single-line
					flat
					clearable
					prepend-inner-icon="search"
					hide-details
				></v-text-field>
			</v-container>
			<v-list two-line class="py-0">

				<v-list-tile avatar ripple @click="gotoDeviceAdd()" v-if="isRunningInBrowser && !this.query">
					<v-list-tile-avatar>
						<i class="fa fa-plus"></i>
					</v-list-tile-avatar>
					<v-list-tile-content>
						<v-list-tile-title class="font-weight-medium">Nieuwe E-finder toevoegen</v-list-tile-title>
					</v-list-tile-content>
					<v-list-tile-action>
						<v-icon color="grey lighten-1">chevron_right</v-icon>
					</v-list-tile-action>
				</v-list-tile>
				<v-divider></v-divider>
				<template v-for="device in devices">
					<v-list-tile
						avatar
						:ripple="!!device.getState()"
						:key="device.id"
						@click="gotoDevice(device)"
						class="e-connectz_list-tile"
						:class="{
							'is-unregistered': !device.is_registered,
							'is-unactivated': device.isWaitingForActivation()
						}">
						<v-list-tile-avatar>
							<v-badge color="blue" v-if="device.isWaitingForActivation()">
								<template v-slot:badge>
									<span>!</span>
								</template>
								<i class="e-finder-icons">{{ device.getIcon() }}</i>
							</v-badge>
							<i class="e-finder-icons" v-else>{{ device.getIcon() }}</i>
						</v-list-tile-avatar>
						<v-list-tile-content>
							<v-list-tile-title class="font-weight-medium list-title">
								<span class="list-title_main">{{ device.name }}</span>
								<span class="list-title_after">({{ device.id_for_humans }})</span>
							</v-list-tile-title>
							<v-list-tile-sub-title>{{ device.getSubtitle() }}</v-list-tile-sub-title>
						</v-list-tile-content>
						<v-list-tile-action v-if="device.getState()">
							<v-icon color="grey lighten-1">chevron_right</v-icon>
						</v-list-tile-action>
					</v-list-tile>
					<v-divider :key="'divider-' + device.id"></v-divider>
				</template>
			</v-list>
		</v-content>
	</div>
</template>

<style lang="stylus" scoped>
	.list-title {
		display: flex;
	}

	.list-title_main {
		flex-shrink: 1;
		text-overflow: ellipsis;
		min-width: 0;
		overflow: hidden;
	}

	.list-title_after {
		color: #999;
		font-weight: normal;
		font-size: 1rem;
		padding-left: .5rem
	}

	.v-list__tile__action {
		min-width: 2.5rem
	}
</style>

<script>
  export default {
    computed: {
      devices() {
        return this.$store.getters.devices
          .filter(item => {
            if (this.query) {
              return item.name.toLowerCase().includes(this.query.toLowerCase()) ||
                item.id_for_humans.toLowerCase().includes(this.query.toLowerCase());
            } else {
              return item;
            }
          })
          // Sort array of objects by boolean properties:
          // https://stackoverflow.com/questions/41104829/how-to-sort-array-of-objects-by-its-boolean-properties/41105161
          .sort(
            (a, b) =>
              b.isWaitingForActivation() - a.isWaitingForActivation()
              || !!b.activated_at - !!a.activated_at
          );
      }
    },
    data() {
      return {
        query: '',
        isRunningInBrowser: process.env.CORDOVA_PLATFORM === 'browser'
      };
    },
    methods: {
      showMenu() {
        this.$store.dispatch('openMainMenu');
      },
      gotoMap() {
        return this.$router.push({ name: 'devices.index' });
      },
      gotoDeviceAdd() {
        return this.$router.push({ name: 'devices.add' });
      },
      gotoDevice(device) {
        if (device.isWaitingForActivation()) {
          return this.$router.push({ name: 'devices.activate', params: { id: device.id } });
        }
        if (!device.getState()) return;
        this.$router.push({ name: 'devices.show', params: { id: device.id } });
      }
    }
  };
</script>


